import { Flex, Text, Image } from "@chakra-ui/react";
import QrCodeIcon from "./assets/qrcode.png";
import YArrowIcon from "./assets/y-arrow.svg";
import MoneyIcon from "./assets/money.png";
import { useNavigate } from "react-router-dom";
const PaymentMethod = () => {
  const navigate = useNavigate();
  const handleGoDirectPay = () => {
    navigate("/directPay");
  };
  const handleGoCharge = () => {
    navigate("/charge");
  };

  return (
    <Flex
      sx={{
        marginTop: "80px",
      }}
      justify={"space-around"}
    >
      <Flex
        sx={{
          width: "140px",
        }}
        flexDir={"column"}
        align={"center"}
        justify={"center"}
        onClick={handleGoDirectPay}
      >
        <Flex
          sx={{
            width: "140px",
            height: "140px",
            background: "#fff",
            border: "1px solid #D8762B",
            borderRadius: "50%",
          }}
          align={"center"}
          justify={"center"}
        >
          <Image
            src={QrCodeIcon}
            sx={{
              width: "32px",
              height: "32px",
            }}
          ></Image>
        </Flex>

        <Text
          sx={{
            color: "#D8762B",
            textAlign: "center",
            fontSize: "20px",
            fontWeight: 700,
            marginTop: "5px",
          }}
        >
          QR Code
        </Text>
        <Text
          sx={{
            color: "#D8762B",
            textAlign: "center",
            fontSize: "12px",
            fontWeight: 400,
            marginTop: "4px",
          }}
        >
          Direct Pay
        </Text>
        <Image
          src={YArrowIcon}
          sx={{
            width: "26px",
            marginTop: "5px",
          }}
        ></Image>
      </Flex>
      <Flex
        sx={{
          width: "140px",
        }}
        flexDir={"column"}
        align={"center"}
        justify={"center"}
      >
        <Flex
          sx={{
            width: "140px",
            height: "140px",
            background: "#D8762B",
            border: "1px solid #D8762B",
            borderRadius: "50%",
          }}
          align={"center"}
          justify={"center"}
          onClick={handleGoCharge}
        >
          <Image
            src={MoneyIcon}
            sx={{
              width: "52px",
            }}
          ></Image>
        </Flex>

        <Text
          sx={{
            color: "#D8762B",
            textAlign: "center",
            fontSize: "20px",
            fontWeight: 700,
            marginTop: "5px",
          }}
        >
          Charge
        </Text>
        <Text
          sx={{
            color: "#D8762B",
            textAlign: "center",
            fontSize: "12px",
            fontWeight: 400,
            marginTop: "4px",
          }}
        >
          Set Amount
        </Text>
        <Image
          src={YArrowIcon}
          sx={{
            width: "26px",
            marginTop: "5px",
          }}
        ></Image>
      </Flex>
    </Flex>
  );
};

export default PaymentMethod;
